import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const isOverdueTask = (endDate: string | null): boolean => {
    if (!endDate) {
        return false;
    }

    const formattedEndDate = dayjs(endDate, 'DD.MM.YYYY', true);
    if (!formattedEndDate.isValid()) {
        return false;
    }

    return dayjs().isAfter(formattedEndDate, 'day');
};
